export default __webpack_public_path__ + "static/media/greenTicket@3x.7cdbddb3.png";